<template>
  <div class="editor-controls">
    <div class="editor-controls__group flex--col-start-start">
      <FormInput
        class="editor-controls__checkbox text--clr-black"
        type="checkbox"
        label="show_ui_element_keys"
        inputId="editor-controls"
        v-model="showUiElementKeys"
      />
      <FormInput
        class="editor-controls__checkbox text--clr-black"
        type="checkbox"
        label="show_ui_text_content_keys"
        inputId="editor-controls"
        v-model="showUiTextContentKeys"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  data: () => ({}),

  methods: {
    ...mapMutations("content", ["SET_SOURCE_MODE_CONFIG"])
  },

  computed: {
    ...mapState("content", ["sourceModeConfig"]),

    showUiElementKeys: {
      get() {
        return this.sourceModeConfig.showUiElementKeys
      },

      set(val) {
        this.SET_SOURCE_MODE_CONFIG({
          ...this.sourceModeConfig,
          showUiElementKeys: val
        })
      }
    },

    showUiTextContentKeys: {
      get() {
        return this.sourceModeConfig.showUiTextContentKeys
      },

      set(val) {
        this.SET_SOURCE_MODE_CONFIG({
          ...this.sourceModeConfig,
          showUiTextContentKeys: val
        })
      }
    }
  }
}
</script>

<style lang="scss">
.editor-controls {
  position: fixed;
  top: 1em;
  left: 1em;
  background-color: white;
  border: 1px solid lightpink;
  padding: 1em;
  z-index: 1000;
}
</style>
